import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Hidden,
  Typography
} from '@mui/material'
import LanguageMenu from './menu'
import { useStyles } from './style'

const TranslateDialog = ({ open, onClose, languages, value, onTranslate }) => {
  const [lang, setLang] = useState(value)
  const classes = useStyles()

  const handleChange = value => setLang(value)

  const handleApply = () => {
    onTranslate(lang)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      aria-labelledby='dialog-title'
    >
      <DialogTitle id='dialog-title' className={classes.title}>
        Translate the article
      </DialogTitle>
      <DialogContent>
        <Hidden smDown>
          <Typography
            variant='subtitle2'
            color='textSecondary'
            className={classes.subtitle}
          >
            Please select one of the options below
          </Typography>
        </Hidden>
        <LanguageMenu
          value={lang}
          onChange={handleChange}
          languages={languages}
          className={classes.menu}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-test='translate-dialog-cancel'>
          Cancel
        </Button>
        <Button
          onClick={handleApply}
          color='primary'
          data-test='translate-dialog-apply'
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TranslateDialog
